
import { Card, CardContent, Avatar, Chip, Typography, Box } from '@mui/material';
import { Mail, Phone, Work } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import Layout from '../components/layout/Calayout';

const ContactCard = ({ contact, isPrimary }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={cardVariants}
      transition={{ duration: 0.5 }}
    >
      <Card 
        sx={{
          mb: 2,
          bgcolor: isPrimary ? 'primary.main' : 'background.paper',
          color: isPrimary ? 'primary.contrastText' : 'text.primary'
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Avatar
              sx={{
                bgcolor: isPrimary ? 'common.white' : 'primary.main',
                color: isPrimary ? 'primary.main' : 'common.white'
              }}
            >
              {contact?.name?.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
                {contact?.name}
              </Typography>
              <Chip
                label={isPrimary ? 'Primary Contact' : 'Secondary Contact'}
                variant={isPrimary ? 'outlined' : 'filled'}
                size="small"
                sx={{
                  mt: 0.5,
                  color: isPrimary ? 'common.white' : undefined,
                  borderColor: isPrimary ? 'common.white' : undefined
                }}
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Work
                sx={{
                  fontSize: 18,
                  color: isPrimary ? 'common.white' : 'text.secondary'
                }}
              />
              <Typography variant="body2">{contact?.position}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Mail
                sx={{
                  fontSize: 18,
                  color: isPrimary ? 'common.white' : 'text.secondary'
                }}
              />
              <Typography variant="body2">{contact?.email}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Phone
                sx={{
                  fontSize: 18,
                  color: isPrimary ? 'common.white' : 'text.secondary'
                }}
              />
              <Typography variant="body2">{contact?.phone}</Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

const ClientDirectory = () => {
  const { primaryContact, secondaryContact } = useSelector(
    (state) => state.kyc.selectedContactInfo
  );

  return (
    <Layout>
      <Box sx={{ mt: 2 }}>
      {primaryContact && <ContactCard contact={primaryContact} isPrimary={true} />}
      {secondaryContact && <ContactCard contact={secondaryContact} isPrimary={false} />}
    </Box>
  

    </Layout>
    );
    
};

export default ClientDirectory;
